import { Auth } from "aws-amplify";
import { CognitoUserSession } from "amazon-cognito-identity-js";
import { addUserTokensToStorage, signOutUser } from "../../../redux/actions/actionCreators";

export const refreshSessionAndTokens = async (reduxDispatch = (x: any) => null) => {
  const session = await Auth.currentSession().catch(async (err) => {
    // console.log("Session timed out most likely: ", err);
    reduxDispatch(signOutUser(true));
    throw err;
  });

  const refreshToken = session.getRefreshToken();
  return await new Promise(async (resolve, reject) => {
    const cognitoUser = await Auth.currentAuthenticatedUser().catch(async (err) => {
      // console.log(`Error after trying to refresh session should not have happened: `, err);
      reduxDispatch(signOutUser(true));
      return reject(err);
    });

    cognitoUser.refreshSession(refreshToken, async (err: any, refreshedSession: any) => {
      if (err) {
        console.error(err);
        return reject(err);
      }
      const tokens = getTokens(refreshedSession);
      reduxDispatch(addUserTokensToStorage(tokens));
      return resolve(tokens);
    });
  });
};

const getTokens = function (session: CognitoUserSession) {
  const res = {
    accessToken: session.getAccessToken().getJwtToken(),
    idToken: session.getIdToken().getJwtToken(),
    refreshToken: session.getRefreshToken().getToken(),
  };
  return res;
};
